import React from "react";
import { Line } from "@ant-design/plots";

const LineChart = () => {
  // Use the provided JSON data directly
  const data = [
    { month: "Jan", value: 4623 },
    { month: "Feb", value: 2208 },
    { month: "March", value: 182 },
    { month: "April", value: 6145 },
    { month: "May", value: 2016 },
    { month: "June", value: 257 },
    { month: "July", value: 508 },
    { month: "August", value: 2916 },
    { month: "Sep", value: 289 },
    { month: "Oct", value: 6268 },
    { month: "Nov", value: 4512 },
    { month: "Dec", value: 428 },
  ];

  const config = {
    data,
    xField: "month",
    yField: "value",
    point: {
      size: 5,
      shape: "diamond",
    },
    tooltip: {
      showMarkers: false,
    },
    interactions: [{ type: "marker-active" }],
  };

  return <Line {...config} />;
};

export default LineChart;
